import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import "@/utils/functions"; //must move to App
import "@/utils/axios";
import i18n from "@/i18n/index";
import firebase from "firebase/app";
// import "firebase/firestore";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import VueFileAgent from "vue-file-agent";
import VueFileAgentStyles from "vue-file-agent/dist/vue-file-agent.css";
import VueCountdownTimer from "vuejs-countdown-timer";
import VCalendar from "v-calendar";

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "vue-multiselect/dist/vue-multiselect.min.css";
import "pretty-checkbox/dist/pretty-checkbox.min.css";
import "@/assets/css/app.scss";
import "@/assets/css/main.css";

Vue.use(VueFileAgent);
Vue.use(VueFileAgentStyles);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueBottomSheet);
Vue.use(VueCountdownTimer);
Vue.use(VCalendar);
Vue.config.productionTip = false;

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyApS_5ZXrzgUhyANTMOkkLCbMppDDAKzrA",
  authDomain: "fireblogsyt-9da04.firebaseapp.com",
  projectId: "fireblogsyt-9da04",
  storageBucket: "fireblogsyt-9da04.appspot.com",
  messagingSenderId: "965657150267",
  appId: "1:965657150267:web:606a0cfafab57bf3496d1e",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
